<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex lg12">

        <sp-360-panel :title="'management.profiles.manage-profiles' | translate">
          <div data-vv-scope="formPerfis">
            <div class="row">
              <div class="flex lg12" style="margin-top:56px;">
                <fieldset>
                  <div class="form-group" :class="{ 'has-error': errors.has('formPerfis.nome') }">
                    <div class="input-group">
                      <va-input id="nome" name="nome" required v-model="perfil.nome" aria-required="true"  v-validate="'required'" label="Nome" />
                    </div>
                  </div>
                  <div class="form-group" :class="{ 'has-error': errors.has('formPerfis.privilegios') }">
                    <div class="input-group" >
                    <multiselect
                      id="listaPrivilegios"
                      name="privilegios"
                      v-validate="'required'"
                      :placeholder="'management.profiles.privileges' | translate"
                      :options="options.privilegios"
                      label="nome"
                      track-by="nome"
                      v-model="perfil.listaPrivilegio"
                      open-direction="bottom"
                      :multiple="true"
                      :close-on-select="false"
                    />
                    <!-- <small v-show="errors.has('formPerfis.privilegios')"
                             class="help text-danger">{{
                        errors.first('formPerfis.privilegios')
                        }}
                      </small> -->
                    </div>
                  </div>
                  <div class="row">
                    <div class="flex lg6">
                      <va-button type="button" @click="limpar()" class="btn btn-primary btn-sm pull-left">
                        {{'management.clear'| translate}}
                      </va-button>
                    </div>
                    <div class="flex lg6">
                      <va-button type="button" @click="persiste()" class="btn btn-primary btn-sm pull-right">
                        {{'management.save'| translate}}
                      </va-button>
                    </div>
                  </div>
                </fieldset>
              </div>               
                  <va-input class="filter-input"
                    v-model="termo"
                    placeholder="Pesquisar"
                    removable
                    @input="pesquisa"
                  >
                    <va-icon name="fa fa-search" slot="prepend" />
                </va-input>
              <div class="flex lg12">
                  <sp360-data-table id="tabelaPerfil" ref="tabelaPerfil"
                    :apiMode="false"
                    :data="dadosPerfilFiltrado.data"
                    :fields="tableFields"
                    :dataModeFilterableFields="dataModeFilterableFields"
                    :sortFunctions="sortFunctions"
                    :itemsPerPage="itemsPerPage"
                    :filterInputShown="true"
                    @editarRow="editar($event)"
                    @deletarRow="deletarModal($event)"
                  />

              </div>
            </div>

          </div>
        </sp-360-panel>

      </div>
    </div>
    <va-modal ref="perfilDelModal"
                   :okText="'management.delete' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="deletar()"
                   @cancel="cancelarDelecao()"
                   :title="'management.confirmation' | translate"
                   v-model="openModalDelecao"
                   >
      <template slot="default">
        {{'management.profiles.confirmationText' | translate}}
      </template>
    </va-modal>
  </div>
</template>

<script>
import Vue from 'vue'

import Multiselect from 'vue-multiselect'
import PerfilService from '@/services/PerfilService'
import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  components: { Multiselect, Sp360DataTable, Sp360Panel },
  name: 'perfis',
  computed: {

  },
  data () {
    return {
      termo: null,
      openModalDelecao: false,
      perfil: PerfilService.newPerfil(),
      options: {
        privilegios: [],
      },
      dadosPerfil: {
        'data': [],
      },
      dadosPerfilFiltrado: {
        'data': [],
      },
      itemsPerPage: [
        {
          value: 8,
        },
      ],
      tableFields: [
        {
          name: 'id',
          sortField: 'id',
          title: this.$t('management.profiles.id'),
          width: '5%',
        },
        {
          name: 'nome',
          sortField: 'nome',
          title: this.$t('management.profiles.name'),
        },
        {
          name: '__slot:edicao',
          dataClass: 'action-slot',
          width: '5%',
        },
        {
          name: '__slot:delecao',
          dataClass: 'action-slot',
          width: '5%',
        },
      ],
      dataModeFilterableFields: ['nome'],
      sortFunctions: {
        'id': MetodosGlobais.ordenaTabela,
        'nome': MetodosGlobais.ordenaTabela,
      },
    }
  },
  beforeCreate () {
    this.$store.dispatch('privilegio/getAllPrivilegio').then(
      retorno => {
        this.options.privilegios = _.sortBy(retorno.data, 'nome')
      }
    )
    this.$store.dispatch('perfil/getAllPerfil').then(
      retorno => {
        this.dadosPerfil.data = retorno.data
        this.dadosPerfilFiltrado.data = retorno.data
        this.updateTabelaPerfil(this.dadosPerfilFiltrado)
      }
    )
  },
  methods: {
    pesquisa: _.debounce(function (term) {
      this.termo = term
      let a = []

      if((!Number.isNaN(parseInt(term))) && term !="" ){
        a = this.$refs.tabelaPerfil.filterByNumber(this.dadosPerfil.data, this.termo)
      }else{
        a = this.$refs.tabelaPerfil.filterByString(this.dadosPerfil.data, this.termo)
      }
      
      this.dadosPerfilFiltrado.data = a
      this.updateTabelaPerfil(this.dadosPerfilFiltrado)
    }, 400),

    valida (usuario) {
      return this.$validator.validateAll('formPerfis').then(valid => {
        return valid
      })
    },
    persiste () {
      event.preventDefault()
      this.valida().then(valido => {
        if (!valido) {
          this.showToast(this.$t('management.incorrectFields'), constantes.TOASTED_ERROR)
        } else {
          if (this.perfil.id == 0) {
            this.$store.dispatch('perfil/postPerfilRetornar', this.perfil).then(
              retorno => {
                this.showToast(this.$t('management.profiles.profile') + ` ${retorno.data.nome}` + this.$t('management.inserted'), constantes.TOASTED_SUCCESS)
                this.dadosPerfil.data.push(retorno.data)
                
                this.limpar()
              }
            )
          } else {
            let index = _.findIndex(this.dadosPerfil.data, uni => uni.id == this.perfil.id)
            this.$store.dispatch('perfil/putPerfil', this.perfil)
              .then(retorno => {
                this.updatePerfil(this.perfil, index)
                this.showToast(this.$t('management.profiles.profile') + ` ${this.perfil.nome}` + this.$t('management.updated'), constantes.TOASTED_SUCCESS)
                this.limpar()
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.updatedError'), constantes.TOASTED_ERROR)
              })
          }
        }
      })
    },
    updatePerfil (perfil, index) {
      Vue.set(this.dadosPerfil.data, index, perfil)
      this.$refs.tabelaPerfil.resetPage()
    },
    editar (event) {
      this.perfil = _.cloneDeep(event.rowData)
    },
    deletarModal (event) {
      this.perfilADeletar = event.rowData
      this.openModalDelecao = true;
    },
    deletar () {
      this.$store.dispatch('perfil/deletePerfil', this.perfilADeletar.id).then(
        retorno => {
          this.showToast(this.$t('management.profiles.profile') + ` ${this.perfilADeletar.nome}` + this.$t('management.deleted'), constantes.TOASTED_SUCCESS)
          this.dadosPerfil.data = this.dadosPerfil.data.filter(uni => {
            return uni.id != this.perfilADeletar.id
          })
          
        }
      )
        .catch(err => {
          console.error(err)
          this.showToast(this.$t('management.deletedError'), constantes.TOASTED_ERROR)
        })
    },
    cancelarDelecao () {
      this.perfilADeletar = {}
    },
    atualiza (usuario) {

    },
    limpar () {
      event.preventDefault()
      this.perfil = PerfilService.newPerfil()
      this.$validator.reset()
    },
    updateTabelaPerfil(dados){
      this.$set(this.dadosPerfilFiltrado, 'data', dados.data)
    }
  },
  created () {
    // this.options.perfis = ['ADMIN', 'PREFEITO', 'MANAGER', 'SECRETARIO'];
    this.options.perfis = [{ id: 1, desc: 'ADMIN' }, { id: 2, desc: 'PREFEITO' }, { id: 3, desc: 'MANAGER' }, { id: 4, desc: 'SECRETARIO' }]
  },
}
</script>

<style lang="scss">
  @import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
  .multiselect__placeholder {
    color: $brand-success;
  }
</style>
